import './scss/index.scss';

import { dcFactory } from '@deleteagency/dc';
import PredictiveInputComponent from './js/predictive-input.component';
import LocationButtonComponent from './js/location-button.component';

dcFactory.register(PredictiveInputComponent);
dcFactory.register(LocationButtonComponent);
